import React, { useRef, useEffect } from "react"
import Flatpickr from "react-flatpickr"
import { FormGroup, Label, InputGroup, FormFeedback } from "reactstrap"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import "react-datepicker/dist/react-datepicker.css"

const FormikDatePicker = ({
  label,
  name,
  placeholder = "Selecciona una fecha",
  dateFormat = "Y-m-d",
  formik, // Se recibe el objeto formik directamente
  readOnly = false,
  ...props
}) => {
  const flatpickrRef = useRef(null)

  const optionsFlatpickr = {
    locale: Spanish,
    altInput: true,
    dateFormat: dateFormat,
    enableTime: false,
  }

  // Aplicar el bloqueo del control si `readOnly` es true
  useEffect(() => {
    if (flatpickrRef.current && flatpickrRef.current.flatpickr) {
      if (readOnly) {
        flatpickrRef.current.flatpickr.input.setAttribute(
          "disabled",
          "disabled"
        )
      } else {
        flatpickrRef.current.flatpickr.input.removeAttribute("disabled")
      }
    }
  }, [readOnly])

  // Función que abre el calendario al hacer clic en el ícono
  const handleIconClick = () => {
    if (flatpickrRef.current && flatpickrRef.current.flatpickr && !readOnly) {
      flatpickrRef.current.flatpickr.open()
    }
  }

  // Opcional: Si necesitas interactuar con la instancia de Flatpickr
  useEffect(() => {
    if (flatpickrRef.current) {
      // Puedes acceder a la instancia de Flatpickr a través de flatpickrRef.current.flatpickr
    }
  }, [])

  return (
    <FormGroup>
      {label && <Label htmlFor={name}>{label}</Label>}
      <InputGroup>
        <Flatpickr
          ref={flatpickrRef}
          value={formik.values[name] || ""}
          onChange={(selectedDates, dateStr) => {
            formik.setFieldValue(name, dateStr) // Actualiza el valor en Formik
          }}
          onClose={() => {
            formik.setFieldTouched(name, true) // Marca el campo como tocado
          }}
          placeholder={placeholder}
          options={optionsFlatpickr}
          className={`form-control ${
            formik.touched[name] && formik.errors[name] ? "is-invalid" : ""
          }`}
          readOnly={readOnly} // Deshabilita el input si está en modo lectura
          {...props}
        />
        <div
          className="input-group-text"
          style={{ cursor: "pointer" }}
          onClick={handleIconClick}
        >
          <i className="bx bx-calendar"></i>
        </div>
        {formik.touched[name] && formik.errors[name] && (
          <FormFeedback className="d-block">{formik.errors[name]}</FormFeedback>
        )}
      </InputGroup>
    </FormGroup>
  )
}

export default FormikDatePicker
